import {
  Component,
  Inject,
  Input,
  OnDestroy,
  OnInit,
  Optional,
} from '@angular/core';
import { ContactsService } from '@boxx/contacts-core/lib/services/contacts.service';
import { ContactStore } from '@boxx/contacts-core/lib/state/contact.store';
import {
  EventModel,
  EventsStore,
  IEventReminder,
  ILocalNotificationsService,
  LOCAL_NOTIFICATIONS_SERVICE,
} from '@boxx/events-core';
import { LoadingController, ModalController } from '@ionic/angular';
import { TranslateService } from '@ngx-translate/core';
import * as moment_ from 'moment';
import { Subject } from 'rxjs';
import { filter, skip, takeUntil, withLatestFrom } from 'rxjs/operators';
import { BoxxUtilsService } from 'src/services/BoxxUtils.service';
import { FirebaseAnalyticsService } from 'src/services/NativeFirebase/NativeFirebase.service';
import { IEventDetailEmitter } from '../event-form/event-form.component';

// To prevent compiling errors
const moment = moment_;

@Component({
  // eslint-disable-next-line @angular-eslint/component-selector
  selector: 'boxx-event-create',
  templateUrl: './event-create.modal.html',
  styleUrls: ['./event-create.modal.scss'],
})
export class  EventCreateComponent implements OnInit, OnDestroy {
  @Input() event: EventModel;
  @Input() showLoader: boolean; // <-- this is passed in to template

  destroyed$ = new Subject<boolean>();

  translations: any;

  canSaveData = false;

  eventToSave: EventModel;
  

  constructor(
    @Optional()
    @Inject(LOCAL_NOTIFICATIONS_SERVICE)
    private localNotifSrvc: ILocalNotificationsService,
    private store: EventsStore,
    public loadingCtrl: LoadingController,
    private modalCtrl: ModalController,
    private translate: TranslateService,
    private boxxUtils: BoxxUtilsService,
    public contactsStore: ContactStore,
    public contactService: ContactsService,
    private firebaseService: FirebaseAnalyticsService,
  ) {
    this.translate
      .get(['FORMS', 'EVENTS_MODULE', 'ERRORS', 'SUCCESS'])
      .pipe(takeUntil(this.destroyed$))
      .subscribe((t: any) => (this.translations = t));
  }

  ngOnInit() {
    this.handleSuccess();
    this.handleError();
    this.handleLoading();

    this.contactsStore.contacts.data$
      .pipe(takeUntil(this.destroyed$))
      .subscribe(() => {});

    this.contactsStore.contacts.fetched$
      .pipe(takeUntil(this.destroyed$))
      .subscribe((fetched) => {
        if (!fetched) {
          this.contactsStore.contacts.fetch();
        }
      });
  }

  ngOnDestroy() {
    this.destroyed$.next(true);
    this.destroyed$.complete();
  }

  private handleLoading() {
    this.store.loading$
      .pipe(skip(1), takeUntil(this.destroyed$))
      .subscribe((loading) => {
        // setTimeout( () => {
        //   this.boxxUtils.handleLoading(loading);
        // }, 200);
      });
  }

  formChange(val: IEventDetailEmitter) {
    this.canSaveData = val.hasChanges && val.valid;
    this.eventToSave = val.data;
    let to = new Date(this.eventToSave.datetimeTo);
    let from = new Date(this.eventToSave.datetimeFrom);

    if((to.getTime() < from.getTime()) && this.canSaveData){
      this.canSaveData = false;
    }
  }

  upsertEvent() {
    this.store.createEvent(this.eventToSave);
  }

  close() {
    this.modalCtrl.dismiss();
  }

  private handleSuccess() {
    this.store.success$
      .pipe(
        takeUntil(this.destroyed$),
        filter((success) => ['CREATE'].includes(success?.after))
      )
      .subscribe((success) => {
        const toast = this.boxxUtils.showToastSuccess({
          message:
            this.translations.SUCCESS.EVENTS[success.after.toLowerCase()],
        });

        this.firebaseService.logFullEvent('user_register_event', {});

        this.modalCtrl.dismiss();

        const momentStartTime = moment(this.eventToSave.datetimeFrom)
          .subtract(10, 'minutes')
          .set({ second: 0, millisecond: 0 })
          .toDate();

        const reminder: IEventReminder = {
          id: success.data,
          title: this.translations.EVENTS_MODULE.REMINDER_TITLE,
          text: this.eventToSave.title,
          date: momentStartTime,
        };

        if(this.eventToSave.attendees && this.eventToSave.attendees.length > 0){
          this.eventToSave.attendees.forEach( (value, index, array) => {
            const dataEvent = {
                action_type: 'CONTACT_SCHEDULED',
                entity: 'contacts',
                entity_id: value.id,
              }

              this.saveContactEventSchedule(value.id, success.data.id); 
          });
        }

        if (this.localNotifSrvc) {
          this.localNotifSrvc.setReminder(reminder);
        }
      });
  }

  saveContactEventSchedule(contactId: number, eventId: number){
    this.firebaseService.setScreenName('CONTACT > EVENTS > CREATE');
    this.contactsStore.interactions.create(contactId, {
      action_type: 'CONTACT_SCHEDULED',
      entity: 'schedule',
      entity_id: eventId,
    });
  }

  private handleError() {
    this.store.error$
      .pipe(
        takeUntil(this.destroyed$),
        filter((error) => ['CREATE'].includes(error?.after))
      )
      .subscribe((error) => {
        this.boxxUtils.showToastError({
          message: this.translations.ERRORS.EVENTS[error.after.toLowerCase()],
        });
      });
  }
}
